import React, { useEffect, useState, useCallback } from "react";
import ListReportsUnimed from "./list.jsx";
import {
  Spinner,
  Pagination,
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Table,
  Button,
  PaginationItem,
  PaginationLink,
  Alert,
  Label,
} from "reactstrap";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { validateDates } from "../../utils/validations";
import { Suport } from "./styles";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { deleteCookies } from "../../utils/functions";
import { useHistory, useLocation } from "react-router-dom";
import {
  faMicroscope,
  faSort,
  faBroom,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ReportsUnimedView() {
  useEffect(() => {
    document.title = "CEDAP | Painel - Unimed";
  }, []);
  const [showWithoutOutcome, setShowWithoutOutcome] = useState(true);
  const [groupedReports, setGroupedReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const qtdPerPage = 5; // meses por página
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState("desc");
  const [reports, setReports] = useState([]);
  const [isFilteredByDate, setIsFilteredByDate] = useState(false);
  const [isReportsNull, setReportsNull] = useState(false);
  const [fields, setFields] = useState({ dateStart: "", dateEnd: "" });
  const filteredReports = reports.filter((report) => {
    const isWithoutOutcome =
      report.CodDesfecho === null && report.DtaDesfecho === null;

    if (showWithoutOutcome) {
      return isWithoutOutcome; // mostra só os sem desfecho
    } else {
      return !isWithoutOutcome; // mostra só os com desfecho
    }
  });

  const orderedReports = [...filteredReports].sort((a, b) => {
    const dateA = new Date(a.DtaSolicitacao);
    const dateB = new Date(b.DtaSolicitacao);
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });

  const groupedByPatient = Object.values(
    orderedReports.reduce((acc, report) => {
      if (!acc[report.MatConvenio]) {
        acc[report.MatConvenio] = [];
      }
      acc[report.MatConvenio].push(report);
      return acc;
    }, {}),
  );

  const qtdPages = Math.ceil(groupedByPatient.length / qtdPerPage);
  // Pega somente os meses da página atual
  const paginatedReports = groupedByPatient.slice(
    qtdPerPage * (page - 1),
    qtdPerPage * page,
  );
  const history = useHistory();
  const location = useLocation();
  const token = cookie().get("tokenDoc");
  const username = cookie().get("username");
  const getReportsByDate = useCallback(async () => {
    const validationError = validateDates(fields.dateStart, fields.dateEnd);

    if (validationError) {
      alert(validationError);
      return;
    }
    setIsLoading(true);

    try {
      const response = await api()
        .user()
        .getAllUnimedMamaByDate(
          token,
          username,
          fields.dateStart,
          fields.dateEnd,
        );
      if (response.status === 401) {
        await deleteCookies();
        return history.replace({ pathname: "/login" });
      }

      if (response.status === 200) {
        if (response.output === null) {
          setReportsNull(true);
          setIsLoading(false); // muito importante
          return;
        }
        setReports(response.output);
        setPage(1); // resetar paginação ao filtrar
        setIsFilteredByDate(true);
        setIsLoading(false);
      } else if (response.status === 404) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [fields, history, token]);

  const getReports = useCallback(async () => {
    try {
      const response = await api().user().getAllUnimedMama(token);

      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/login" });
        return;
      }

      if (response.status === 200) {
        setIsFilteredByDate(false);
        setReports(response.output);
        setIsLoading(false);
      } else if (response.status === 404) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [history, token]);

  useEffect(() => {
    if (username) {
      getReports();
    }

    if (location.state?.successMessage) {
      alert(location.state.successMessage);
      history.replace({ pathname: location.pathname, state: {} });
    }
  }, [username, location, history, getReports]);

  const refreshReports = () => {
    if (isFilteredByDate) {
      getReportsByDate();
    } else {
      getReports();
    }
  };

  const PaginationComponent = () => {
    let elements = [];

    for (let i = page - 3; i < page; i++) {
      if (i > 0) {
        elements.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
          </PaginationItem>,
        );
      }
    }

    for (let i = page - 1; i < qtdPages && i < page + 3; i++) {
      const thisPage = i + 1;
      elements.push(
        <PaginationItem key={thisPage} active={thisPage === page}>
          <PaginationLink onClick={() => setPage(thisPage)}>
            {thisPage}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return (
      <Pagination>
        <PaginationItem>
          <PaginationLink
            first
            onClick={() => setPage(1)}
            disabled={page === 1}
          />
        </PaginationItem>

        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {elements}

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink last onClick={() => setPage(qtdPages)} />
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <div>
      {!errorMessage && (
        <h1>
          <FontAwesomeIcon icon={faMicroscope} />{" "}
          {isFilteredByDate
            ? "Relatório de Exames – Período Selecionado"
            : "Relatório de Exames – Últimos 30 Dias"}
        </h1>
      )}

      {isLoading ? (
        <div>
          <Spinner color="primary" /> Carregando...
        </div>
      ) : errorMessage ? (
        <Alert color="danger">
          Erro ao encontrar exames, atualize a página e tente novamente. Caso o
          problema persista, entre em contato com a equipe de suporte!
        </Alert>
      ) : (
        <>
          {groupedReports.length === 0}

          <>
            {paginatedReports.length === 0}

            <div>
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-0">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Data Início</InputGroupText>
                      </InputGroupAddon>

                      <Input
                        type="date"
                        value={fields.dateStart}
                        onChange={(e) =>
                          setFields({ ...fields, dateStart: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup className="mb-0">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Data Fim</InputGroupText>
                      </InputGroupAddon>

                      <Input
                        type="date"
                        value={fields.dateEnd}
                        onChange={(e) =>
                          setFields({ ...fields, dateEnd: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md={2} style={{ display: "flex", alignItems: "center" }}>
                  <Button color="primary" block onClick={getReportsByDate}>
                    <b>Buscar por Data</b> <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </Col>
              </Row>
            </div>
            <Button
              style={{ margin: "10px 0" }}
              color="light"
              onClick={() => window.location.reload()}
            >
              <b> Limpar filtros </b> <FontAwesomeIcon icon={faBroom} />
            </Button>

            <div style={{ marginBottom: "10px" }}>
              <FormGroup>
                <Button
                  color="light"
                  onClick={() => setShowWithoutOutcome(!showWithoutOutcome)}
                >
                  <FontAwesomeIcon
                    icon={showWithoutOutcome ? faSort : faMicroscope}
                    style={{ marginRight: 6 }}
                  />
                  <b>
                    {showWithoutOutcome
                      ? "Exibindo exames sem desfecho"
                      : "Exibindo apenas exames com desfecho"}
                  </b>
                </Button>
              </FormGroup>
            </div>

            {isReportsNull ? (
              <Alert color="warning">
                Nenhum exame encontrado nas datas selecionadas.
              </Alert>
            ) : (
              <Table striped bordered responsive style={{ marginTop: "10px" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}> </th>
                    <th style={{ textAlign: "center" }}>Cod Exame</th>
                    <th style={{ textAlign: "center" }}>Nome Paciente</th>
                    <th
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onClick={() =>
                        setOrder(order === "desc" ? "asc" : "desc")
                      }
                    >
                      Data Final{" "}
                      <FontAwesomeIcon
                        icon={order === "desc" ? faSort : faSort}
                        style={{
                          marginLeft: 3,
                          fontSize: "1.0rem",
                          opacity: 0.7,
                        }}
                      />
                    </th>
                    <th style={{ textAlign: "center" }}>Diagnostico</th>
                    <th style={{ textAlign: "center" }}>Topografia</th>
                    <th style={{ textAlign: "center" }}>Nome exame</th>
                    <th style={{ textAlign: "center" }}>Matricula</th>
                    <th style={{ textAlign: "center" }}>Desfecho</th>
                    <th style={{ textAlign: "center" }}>Laudo</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedReports.map((patientReports, index) => (
                    <ListReportsUnimed
                      key={index}
                      reports={patientReports}
                      token={token}
                      username={username}
                      showWithoutOutcome={showWithoutOutcome}
                      refreshReports={refreshReports}
                    />
                  ))}
                </tbody>
              </Table>
            )}
            {qtdPages > 1 && <PaginationComponent />}
            <Suport href="https://wa.me/5547991865855" target="_blank">
              <u>Suporte</u>
              <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
            </Suport>
          </>
        </>
      )}
    </div>
  );
}
